import { useAppTranslation } from 'src/i18n/hooks';
import React from 'react';
import { TooltipRenderProps } from 'react-joyride';
const stepOffsetMap = {
  intro: 0,
  main: 1,
  final: 6,
};
const CustomTooltip = ({
  index,
  step,
  primaryProps,
  skipProps,
  tooltipProps,
  type,
}: TooltipRenderProps & { type: 'intro' | 'main' | 'final' }) => {
  const { t } = useAppTranslation('joiRide');
  const displayIndex = (stepOffsetMap[type] ?? 0) + index;
  const isLastStep = type === 'final' && index === 1;

  return (
    <div
      {...tooltipProps}
      className="p-4 bg-white rounded shadow-lg max-w-sm w-[300px] rounded-[16px]"
    >
      <h5 className="text-[20px] font-semibold text-gray-500 mb-2">{step.title}</h5>
      <p className="text-[14px] text-gray-500 font-normal mb-2">{step.content}</p>
      <div className="flex items-center justify-between">
        <div className="text-sm text-gray-500">{displayIndex + 1}/8</div>
        <div className="flex gap-2">
          <button
            {...skipProps}
            className="border border-gray-300 rounded px-3 py-1 text-sm text-black"
          >
            {t('skip')}
          </button>
          <button {...primaryProps} className="bg-blue-600 text-white px-4 py-2 rounded text-sm">
            {isLastStep ? t('done') : t('nextStep')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomTooltip;
